import {
    container,
    title,
    main,
    mainRaised
  } from "assets/jss/material-kit-pro-react.jsx";
  
  import image from "assets/img/danna7.jpg";

  const landingPageStyle = {
    section: {
        minHeight: "90vh",
        maxHeight: "90vh",
        overflow: "hidden",
        padding: "70px 0",
        backgroundPosition: "top center",
        backgroundSize: "cover",
        margin: "0",
        border: "0",
        display: "flex",
        alignItems: "center",
        backgroundImage: "url(" + image + ")"
      },
    container: {
      color: "#FFFFFF",
      ...container,
      zIndex: "2"
    },
    title: {
      ...title,
      display: "inline-block",
      position: "relative",
      marginTop: "30px",
      minHeight: "32px",
      color: "#FFFFFF",
      textDecoration: "none",
      fontWeight: 700,
      fontFamily: "Roboto Slab",
      lineHeight: "1.15em",
      fontSize:"40px"
    },
    subtitle: {
      fontSize: "1.23rem",
      color: "#fff"
    },
    main: {
      ...main
    },
    mainRaised: {
      ...mainRaised
    },
    block: {
      color: "inherit",
      padding: "0.9375rem",
      fontWeight: "500",
      fontSize: "12px",
      textTransform: "uppercase",
      borderRadius: "3px",
      textDecoration: "none",
      position: "relative",
      display: "block"
    },
    inlineBlock: {
      display: "inline-block",
      padding: "0px",
      width: "auto"
    },
    list: {
      marginBottom: "0",
      padding: "0",
      marginTop: "0"
    },
    left: {
      float: "left!important",
      display: "block"
    },
    right: {
      padding: "15px 0",
      margin: "0",
      float: "right"
    },
    icon: {
      width: "18px",
      height: "18px",
      top: "3px",
      position: "relative"
    }
  };
  
  export default landingPageStyle;
  


// WEBPACK FOOTER //
// ./src/assets/jss/material-kit-pro-react/views/errorPageStyle.jsx